import React from 'react';
export const RoundTriangleSvg: React.FC = () => {
  return (
    <svg
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.48877 8.13596C7.0762 8.59003 6.35581 8.56896 5.97048 8.09155L3.74074 5.32895L0.480926 1.66467C-0.092712 1.01986 0.365019 4.65562e-08 1.22806 -2.88934e-08L6.7037 -5.07589e-07L12.7028 -3.78734e-07C13.5766 -3.59966e-07 14.0301 1.04183 13.4348 1.68137L10.0392 5.32895L7.48877 8.13596Z"
        fill="#D3E9CE"
      />
    </svg>
  );
};
